import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useApisPartnerConsolesCompaniesAnalyticsQuestionAnswerCategoriesIndex,
  useDateRange,
  usePartnerConsolesMultiDivisionMultiSectionDropdown,
  usePartnerConsolesCompaniesDropdown,
} from "~/hooks";

import { PartnerConsoleLayout } from "~/components/layouts";
import { AnalyticsPlansCountDisplayBoxes } from "~/components/organisms";

import { LabelWithDropDownField } from "~/ui";

const today = new Date();

export const PartnerConsolesAnalyticsQuestionAnswerCategoriesIndex: FC = () => {
  const query = new URLSearchParams(location.search);
  const companyId = query.get("company_id") || "";
  const breadCrumbItems = [
    {
      label: "パートナー画面",
      href: "/partner_consoles",
    },
    {
      label: "Q&A分析",
      href: "/partner_consoles/analytics/question_answer_categories",
    },
  ];

  const [{ onChangeCompany, dropdownSelectableValue, dropdownValue, company }] =
    usePartnerConsolesCompaniesDropdown({
      defaultCompanyId: companyId,
    });

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
  } = usePartnerConsolesMultiDivisionMultiSectionDropdown({
    companyId: company?.id || "",
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      formattedEndDate,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const { data, isLoading } =
    useApisPartnerConsolesCompaniesAnalyticsQuestionAnswerCategoriesIndex({
      companyId: company?.id || "",
      params: {
        businessDivisionIds: selectedDivisions.map((division) => division.id),
        businessSectionIds: optionSelectedSections.map((section) => section.id),
        fromDate: formattedStartDate || undefined,
        toDate: formattedEndDate || undefined,
      },
      config: {
        enabled: !!(formattedStartDate && formattedEndDate && company),
      },
    });

  return (
    <>
      <PartnerConsoleLayout
        breadCrumbItems={breadCrumbItems}
        companyId={company?.id}
      >
        <LabelWithDropDownField
          required
          labelText="会社"
          name="company"
          options={dropdownSelectableValue}
          value={dropdownValue}
          onChange={onChangeCompany}
        />
        <AnalyticsPlansCountDisplayBoxes
          selectableDivisions={selectableDivisions}
          selectedDivisions={selectedDivisions}
          onDivisionChange={onDivisionChange}
          optionSelectableSections={optionSelectableSections}
          optionSelectedSections={optionSelectedSections}
          onSectionChange={onSectionChange}
          startDate={startDate}
          endDate={endDate}
          onChangeDateRange={onChangeDateRange}
          data={
            data
              ? {
                  managersPostsCount: data.managersPostsCount,
                  ownersPostsCount: data.ownersPostsCount,
                  others: [
                    {
                      count: data.postsClicksCount,
                      title: "クリック数",
                    },
                  ],
                }
              : undefined
          }
          rankings={[
            {
              title: "ユーザー別クリック数",
              data: data?.postsClicksEmployeesRankings,
            },
            {
              title: "Q&A別クリック数",
              data: data?.postsClicksQuestionAnswersRankings,
            },
          ]}
          className="mt-8"
          isLoading={isLoading}
        />
      </PartnerConsoleLayout>
    </>
  );
};
